<template>
    <div class="sup-bady">
        <DocsTypeSwitch class="top-type-switch" :currId="curr_switch_type" :needSerarch="true"
            :docs_type_switch_click="docs_type_switch_click">
        </DocsTypeSwitch>
        <div class="docs-page">
            <DocsTree class="docs-tree" :request_gourp="curr_docs_type" :share_url_data="shareData"
                :tree_node_callback="tree_node_callback"></DocsTree>
            <div class="docs-content" v-if="eltree_sel_data.id">
                <DocsBreadcrumb ref="ref_breadcrumb" class="content-breadcrumb" :switch_type="curr_switch_type">
                </DocsBreadcrumb>
                <DocsMDComp class="docs-content-scroll" :md_comp_tree_node_id="eltree_sel_data.id"
                    :md_comp_update_data="md_comp_update_data"></DocsMDComp>
            </div>
            <DocsScrollAnchor class="docs-scroll-anchor" v-if="eltree_sel_data.id" :anchor_list="scroll_anchor_list"
                :scroll_anchor_callback="scroll_anchor_callback"></DocsScrollAnchor>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, onMounted, getCurrentInstance, nextTick } from 'vue';
import DocsTypeSwitch from '@/components/Docs/DocsTypeSwitch.vue';
import DocsTree from '@/components/Tree/DocsTree.vue';
import DocsBreadcrumb from '@/components/Docs/DocsBreadcrumb.vue';
import DocsMDComp from '@/components/Docs/DocsMDComp.vue';
import DocsScrollAnchor from '@/components/Docs/DocsScrollAnchor.vue'
import { useRouterStore } from '@/stores/router';
import { useMessageStore } from '../../stores/message';

const message_store = useMessageStore();
const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const ref_breadcrumb = ref(null);
const curr_docs_type = ref(proxy.$globalObj.group.toolUseGuide)//当前请求类型
const curr_switch_type = ref(proxy.$globalObj.docs_switch.toolUseGuide)//当前文档类型
const shareData = ref({}) //分享链接数据
const scroll_anchor_list = ref([])// 滚动锚点列表
const eltree_sel_data = ref({})// 目录树选中节点

onBeforeMount(() => {
    let queryDate = proxy.$route.query;
    if (queryDate && queryDate.shareType && queryDate.shareType == 1) {
        shareData.value = queryDate;
        console.log('分享数据 -- ', queryDate);
    }
});

// MARK 类型选择
const docs_type_switch_click = (item) => {
    if (item.route && item.route.length) {
        router_store.navigateTo(item.route);
    }
}
// MARK Tree  节点点击
const tree_node_callback = (data, treeList) => {
    eltree_sel_data.value = data;
    nextTick(()=>{
        message_store.sendMessage(message_store.M_E_TREE_LIST_UPDATE, { treeList: treeList });
    })
    nextTick(() => {
        ref_breadcrumb.value.update_data(data.id, treeList);
    });

    let queryDate = proxy.$route.query;
    if (!(queryDate && queryDate.shareType && queryDate.shareType == 1 && queryDate.treeId && queryDate.treeId == data.id)) {
        router_store.configBrowserAddressRoute({ shareType: 1, treeId: data.id });
    }
}
// MARK ScrollAnchor  点击
const scroll_anchor_callback = (anchorId) => {
    const element = document.getElementById(anchorId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}
// MARK MD 更新数据
const md_comp_update_data = (anchor_list) => {
    scroll_anchor_list.value = anchor_list;
}

</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    background-color: var(--color-main-light-bg-white);

    .top-type-switch {
        position: absolute;
        top: 0;
        left: 0;
        z-index: var(--type-switch-z-index);
    }

    .docs-page {
        position: relative;
        margin-top: 80px;
        width: 100%;
        height: calc(100% - 80px);
        background-color: var(--color-main-light-bg-white);
        display: flex;
        overflow: hidden;

        .docs-tree {
            width: 23%;
        }

        .docs-content {
            position: relative;
            height: 100%;
            width: calc(100% - 23% - 380px);
            display: flex;
            flex-direction: column;
            padding-right: 8px;
            box-sizing: border-box;

            .content-breadcrumb {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 60px;
                background-color: var(--color-main-light-bg-white);
                z-index: var(--breadcrumb-z-index);
            }

            .docs-content-scroll {
                margin-top: 60px;
                height: calc(100% - 60px);
                overflow-y: auto;
            }
        }

        .docs-scroll-anchor {
            height: 100%;
            width: 380px;
        }
    }


}
</style>